import { Company } from '../company/company';

export class Users {
  Data: User[];
  Count: number;
}

export class User {
  Id?: number;
  Uid?: string;
  Account?: string;
  FirstName?: string;
  LastName?: string;
  Comment?: string;
  IsKeyUser?: boolean;
  IsAdminUser?: boolean;
  Company?: Company;
  Role?: Role;
  Organization?: string;
  DeactivatedAt?: string;
  TerminatedAt?: string;
  TerminatedTo?: string;

  constructor(user: User = {}) {
    this.Id = user.Id;
    this.Uid = user.Uid;
    this.Account = user.Account;
    this.FirstName = user.FirstName;
    this.LastName = user.LastName;
    this.Comment = user.Comment;
    this.IsKeyUser = user.IsKeyUser;
    this.IsAdminUser = user.IsAdminUser;
    this.Company = user.Company;
    this.Role = user.Role;
    this.Organization = user.Organization;
    this.DeactivatedAt = user.DeactivatedAt;
    this.TerminatedAt = user.TerminatedAt;
    this.TerminatedTo = user.TerminatedTo;
  }
}

export class Role {
  Id: number;
}
